import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProviderType } from '../../models/project-integration.model';
import { providerColor, providerGlyph } from '../../shared/provider-meta';

export type ProviderBadgeSize = 'sm' | 'md';

/**
 * Brand tile identifying an issue-tracker provider: the Jira logo for Jira, a short
 * text mark for providers without one, always on the provider's brand colour.
 *
 * Lives in `src/app/components/` because requirement and picker surfaces render the
 * same tile; keeping it in one place stops the glyph from drifting apart again.
 */
@Component({
  selector: 'app-provider-badge',
  templateUrl: './provider-badge.component.html',
  styleUrl: './provider-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderBadgeComponent {
  readonly providerType = input.required<ProviderType>();
  readonly size = input<ProviderBadgeSize>('md');
  /** Accessible name. Empty means the badge is decorative and hidden from assistive tech. */
  readonly label = input('');

  readonly color = computed(() => providerColor(this.providerType()));
  readonly glyph = computed(() => providerGlyph(this.providerType()));
}
